export const okrsInsightsSelector = (state) => state.okrsPage.insights;
